"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var div_1 = tslib_1.__importDefault(require("../../div"));
var class_names_1 = tslib_1.__importDefault(require("../../utils/helpers/class-names"));
var PopperContent = function (_a) {
    var className = _a.className, children = _a.children;
    return (react_1["default"].createElement(div_1["default"], { className: (0, class_names_1["default"])('hidden absolute h-auto', className) }, children));
};
exports["default"] = PopperContent;
//# sourceMappingURL=popper-content.js.map